import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { keepStaleInMinutes } from '../../common/queryClient/utils';
import { apiClient } from '../../common/ApiClient';
import { DataObjectSchema } from '../schema';
import { DataObjectUrl } from './DataObjectUrl';

const getConfidentialDataObjects = () =>
  apiClient
    .get<any>(DataObjectUrl.CONFIDENTIAL)
    .then((response) =>
      DataObjectSchema.parseConfidentialDataObjects(response.data)
    );

export const useConfidentialDataObjectsQuery = createApiQueryHook(
  ['confidentialDataObjects'],
  getConfidentialDataObjects,
  keepStaleInMinutes(5)
);
